import { useContext, useMemo } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import { ApplePayStripeForm } from './ApplePayStripeForm';
import { ApplePayAdyenForm } from './ApplePayAdyenForm';
import { InputTaxComponent } from '../InputTaxComponent/InputTaxComponent';

export const ApplePayForm = ({ isDeviceButton }: { isDeviceButton?: boolean }) => {
  const { paymentMethodsSettings } = useContext(CheckoutContext);
  const providerSettings = paymentMethodsSettings.find(
    (paymentMethod) => paymentMethod.paymentMethodName === PaymentMethodEnum.APPLE_PAY
  )!;

  const Component = useMemo(() => {
    if (providerSettings?.provider === ProviderEnum.STRIPE) {
      return <ApplePayStripeForm />;
    }
    if (providerSettings?.provider === ProviderEnum.ADYEN) {
      return <ApplePayAdyenForm />;
    }
    return null;
  }, [providerSettings]);

  return (
    <div className="flex flex-col gap-4">
      {!isDeviceButton && <InputTaxComponent />}
      {Component}
    </div>
  );
};
